module.exports = __webpack_public_path__ + "img/gan_yes.87473e85.png";